import Control from '../controller/Control';
import TEXTS from '../controller/TextVariables';

const FullScreenControl = (props) => {
    const { map, onZoom = () => {}, initExtent } = props;
    const { reset_to_full_extent } = TEXTS.controls;

    const className = 'expand';

    const zoomTo = (e) => {
        map.getView().fit(initExtent, map.getSize());
        onZoom();
    };
    return (
        <Control map={map} className={className} clickHandler={zoomTo}>
            <button className="map-expand" type="button" title={reset_to_full_extent.tooltip} onClick={zoomTo}>
                <span className={'icon-fit'}></span>
            </button>
        </Control>
    );
};

export default FullScreenControl;
